import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';

import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useAlert } from './Alert/Alert';
import { loginAdminstrator } from './loginPageService';
import LoadingProgress from '../content/Alert/SimulateLoading';

const defaultTheme = createTheme();

export default function SignInSide() {
  const { showAlert, setToken, authToken } = useAlert();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
    if (data.get('email') === '' || data.get('password') === '') {
      showAlert('The email or password is empty, please verify', 'warning');
    } else {
      handleLogin(data.get('email'), data.get('password'));
    }
  };

  async function handleLogin(email, password) {
    try {
      setLoading(true);

      
    //  const response = await loginAdminstrator(email, password);

      if (email==='vrsslm92@gmail.com' && password==='Mohitha@20') {
        setLoading(false);
        showAlert('Login successful!', 'success');
        setToken(true);
        localStorage.setItem('authToken', "tokenvaratharaj");
        navigate('/bill-generation');
      } else {
        showAlert('Something went wrong', 'error');
     //   setToken(false);
      }
    } catch (error) {
      console.error('Error during login:', error);
    //  setToken(false);
      showAlert('Login error!', 'error');
    }
  }

  return (
    <div>
      <ThemeProvider theme={defaultTheme}>
        <LoadingProgress loadingProgess={loading} sx={{ display: 'absolute' }} />
        <Grid container component="main" sx={{ height: '100vh' }}>
          <CssBaseline />
          
          {/* Display left-side image only on larger screens */}
          <Grid
            item
            xs={6} // No image for small screens
            sm={6} // No image for small screens
            md={false}
            lg={8}
            sx={{
              backgroundImage: 'url("/images/login/logo-generate.jpeg")',
              backgroundColor: (t) =>
                t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
              backgroundSize: 'cover',
              backgroundPosition: 'center',// Only show on larger screens
            }}
          />

          <Grid item xs={12} sm={12} md={12} lg={4} elevation={6} square sx={{display:'flex',justifyContent:'center'}}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '100vh',
                margin:'0px 10px 0px 10px',
                justifyContent: 'center',
                width:'70%'
              }}
            >
              <Avatar
                sx={{
                  m: 1,
                  bgcolor: 'secondary.main',
                  width: 106,
                  height: 106,
                }}
              >
                <img src="/images/login/locationInSVR.png" alt="Lock" style={{ width: '130px', height: '110px',background:'aliceblue' }} />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>
              <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                />
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
                />
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                  Sign In
                </Button>
                <Grid container>
                  <Grid item xs>
                    <Link href="#" variant="body2">
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link href="#" variant="body2">
                      {"Don't have an account? Sign Up"}
                    </Link>
                  </Grid>
                </Grid>
                <Copyright sx={{ mt: 5 }} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </ThemeProvider>
    </div>
  );
}

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="">
        Thirupathi Maligai
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
